import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";





export class R3DropdownClass<T = any> extends R3VisualComponentBase {

	protected _inputValue = ref<T>();

	constructor(private readonly defaultValue?: T) {
		super();
		this._inputValue.value = this.defaultValue;
	}

	public get inputValue(): T {
		if (this._inputValue) {
			return this._inputValue.value as T;
		}
		return null as T;
	}

	public set inputValue(value: T) {
		if (value !== undefined) {
			this._inputValue.value = value;
		}
	}

	override async setFocus() {

		this.elemento.value?.show();

		//dropDownRef.value?.show();
		// p-dropdown-trigger
		// dropDownRef.value?.show();
		/*nextTick(() => {
			if (!dropDownRef.value) return;

			const element = dropDownRef.value.$el as HTMLElement;
			const trigger = element.querySelector('.p-dropdown-trigger');
			const dropdown = element.querySelector('.p-dropdown') as HTMLElement;

			if (trigger && dropdown) {
				(trigger as HTMLElement).click();
				dropdown.focus();
			}
		});*/

	}


}